export const Home = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3286 4.47921L12.8217 4.08255H12.8339V1.16588H11.6672V3.17896L8.07858 0.370797C7.44392 -0.126203 6.55667 -0.126203 5.922 0.370797L0.671417 4.47921C0.245 4.81288 0 5.31571 0 5.85763V13.9992H5.25V8.74921C5.25 8.4278 5.51133 8.16588 5.83333 8.16588H8.16667C8.48867 8.16588 8.75 8.4278 8.75 8.74921V13.9992H14V5.85763C14 5.31571 13.755 4.81288 13.3286 4.47921ZM12.8333 12.8325H9.91667V8.74921C9.91667 7.78438 9.1315 6.99921 8.16667 6.99921H5.83333C4.8685 6.99921 4.08333 7.78438 4.08333 8.74921V12.8325H1.16667V5.85763C1.16667 5.6768 1.24833 5.50938 1.39067 5.39796L6.64067 1.28955C6.85242 1.12388 7.14758 1.12388 7.35933 1.28955L12.6093 5.39796C12.7517 5.50938 12.8333 5.6768 12.8333 5.85763V12.8325Z"
      fill="currentColor"
    />
  </svg>
);
